import React, { useState } from 'react';
import {Box,Typography} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import ImageViewer from 'react-simple-image-viewer';
import { Close, FileOpen, Remove, TitleRounded } from '@mui/icons-material';

const CardViewDialog = ({visible,setVisible,data,title})=>{

	const theme = useTheme()
	const user = useSelector(state => state?.auth.user);
	const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch()

	const onOpen = () => {
		setVisible(true);
	};
	const onClose = () => {
		setVisible(false);
	};


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					{title}
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{height:800,width:{xs:300,md:450},justifyContent:"center",background:theme.palette.background.default}}>
			<ImageViewer
				src={[data]}
				currentIndex={0}
				disableScroll={ false }
				closeOnClickOutside={ false }
				closeComponent={<><IconButton onClick={()=>{setVisible(false)}}><Close/></IconButton></>}
			/>
			{/* <img resizemode="contain" src={data} width={300} height={700} style={{borderRadius:10}}/> */}
		</DialogContent>
	</Dialog>
	)
}

export default CardViewDialog;